export function objectKeys<T>(obj: T) {
	if (obj === null || typeof obj !== "object") return [];
	return Object.keys(obj) as (keyof T)[];
}
